import type { AdminProfile } from '../entities/admin_profile.entity'
import type { ProfileRepository } from '../repositories/profile_repository'

export class GetAdminProfileUseCase {
  constructor(private readonly repository: ProfileRepository) {}

  execute(): Promise<AdminProfile> {
    return this.repository.getMe()
  }
}
